var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0118 3.16675H28.3471V17.8334H35.6804V10.7934C40.5529 11.6141 45.0072 14.0511 48.3258 17.7118C51.6444 21.3725 53.6341 26.0438 53.9743 30.9732C54.3144 35.9025 52.9853 40.8028 50.2011 44.8847C47.4168 48.9666 43.3395 51.9924 38.626 53.4746C33.9125 54.9569 28.8373 54.8092 24.2179 53.0555C19.5986 51.3017 15.7041 48.044 13.1618 43.8071C10.6196 39.5702 9.57765 34.6009 10.2039 29.6997C10.8301 24.7985 13.0879 20.2507 16.6138 16.7891L19.2381 14.2235L14.1028 8.97475L11.4785 11.5404C6.62022 16.2972 3.56527 22.5939 2.83601 29.3539C2.10675 36.1139 3.74848 42.9173 7.48046 48.6007C11.2125 54.2842 16.8029 58.4946 23.2959 60.5122C29.7888 62.5298 36.7811 62.2291 43.0769 59.6616C49.3727 57.0941 54.5811 52.4193 57.8114 46.4365C61.0417 40.4536 62.0934 33.5344 60.7865 26.862C59.4797 20.1896 55.8955 14.1783 50.6468 9.85619C45.3981 5.53405 38.811 3.16946 32.0118 3.16675ZM24.7919 21.3847L22.8364 19.4291L18.9526 23.3403L20.9082 25.2958L30.0563 34.4556L32.0118 36.4112L35.8838 32.5001L33.9674 30.5445L24.7802 21.3847H24.7919Z",
    fill: "#062021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerNew);
export default __webpack_public_path__ + "static/media/timer-new.aeff47add922ce51214e25c276e486c5.svg";
export { ForwardRef as ReactComponent };